import './css/constants.css'
import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {AnimatePresence} from "framer-motion";
import WindowDimensionsProvider from "./contexts/WindowDimensionsContext.jsx";
import {useEffect, useState} from "react";
import Lenis from "@studio-freight/lenis";
import Home from "./pages/Home";
import {Fleet} from "./pages/Fleet";
import {WhyAvanty} from "./pages/WhyAvanty";
import {Conciergerie} from "./pages/Conciergerie";
import NotFoundPage from "./pages/NotFound";
import {Sanitary} from "./pages/Sanitary";
import {Helicopter} from "./pages/Helicopter";
import {Jet} from "./pages/JetLocation";

function AnimatedRoutes({ language, setLanguage }) {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Home language={language} setLanguage={setLanguage}/>}/>
                <Route path="/fleet" element={<Fleet language={language} setLanguage={setLanguage}/>}/>
                <Route path="/why-avanty" element={<WhyAvanty language={language} setLanguage={setLanguage}/>}/>
                <Route path="/conciergerie" element={<Conciergerie language={language} setLanguage={setLanguage}/>}/>
                <Route path="/sanitary" element={<Sanitary language={language} setLanguage={setLanguage}/>}/>
                <Route path="/jets" element={<Jet language={language} setLanguage={setLanguage}/>}/>
                <Route path="/helicopter" element={<Helicopter language={language} setLanguage={setLanguage}/>}/>
                {/*<Route path="/offers" element={<Offers language={language} setLanguage={setLanguage}/>}/>*/}
                {/*<Route path="/sanitary-flights" element={<SanitaryFlights language={language} setLanguage={setLanguage}/>}/>*/}
                {/*<Route path="/avanty-experience" element={<AvantyExperience language={language} setLanguage={setLanguage}/>}/>*/}
                {/*<Route path="/privacy" element={<Privacy/>}/>*/}
                {/*<Route path="/terms" element={<Terms/>}/>*/}
                <Route path="*" element={<NotFoundPage language={language} />}/>
            </Routes>
        </AnimatePresence>
    );
}

export function App() {
    const [language, setLanguage] = useState(() => {
        const saved = localStorage.getItem('language');
        return saved !== null ? Number(saved) : 0;
    });

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => 1 - Math.pow(1 - t, 30),
            direction: "vertical",
            smooth: true,
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);

        return () => {
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        console.log(language)
    }, [language]);

    return (
        <BrowserRouter>
            <WindowDimensionsProvider>
                <AnimatedRoutes language={language} setLanguage={setLanguage} />
                <ToastContainer />
            </WindowDimensionsProvider>
        </BrowserRouter>
    );
}

export default App;